export default "__VITE_ASSET__B_uhD85D__"